/**
 * MSAL (Microsoft Authentication Library) Configuration
 * Used for Azure AD authentication
 */

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID,
    authority: "https://login.microsoftonline.com/aba8cd75-988b-44bc-adf8-b38c5d48c904",
    redirectUri: import.meta.env.VITE_REDIRECT_URL,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "User.Read"]
};

